<template>
    <div class="container">
      <p class="current">当前位置：<span>{{ typeName == 1?'客服咨询':'用户咨询' }}</span></p>
      <div class="session-box">
        <div class="session-main">
          <div class="listNew" >
            <p class="expertName" >{{ to_user_name }}</p>
            <div v-show="false">
                <div>{{max_id}}.{{ max_time }}</div>
                <div @click="GetListNew()">更新</div>
            </div>
          </div>
          <div class="top-main" id="output" @scroll="showScroll()">
                <p v-if="loading">加载中...</p>
                <p v-if="noMore">没有更多了</p>
                
               
               
            <div :class="item.isfrom == '0'?'rightInfo':'leftInfo'"  v-for="(item,index) in info" :key="index" :id="index+1">
              <div>

                <p class="time"><span>{{ item.create_time }}</span></p>
                <p class="contextP">
                    <span>{{ item.message }}</span>
                </p>
              </div>
            </div>
           
           
          </div>
          
          
          <div class="bottom-input">
            <el-input v-model="notedata" placeholder="请输入......" @keyup.enter.native="send()"></el-input>
            <el-button :type="notedata == ''?'':'primary'" :disabled="notedata == ''?true:false" @click="send()">发送</el-button>
          </div>
        </div>
      </div>
     
    </div>
</template>
  
  <script>
//   import Menu from './index.vue'
import { getTimeDate } from '@/js/getTime'
export default {
  data(){
    return{
      count: ['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20',],
      loading: false,
      pullStatus: 1,

      DialogHeight:0,
      notedata:'',
      updateTime: '',
      info: [],
      isok: false,
      CaiYangTop:0,
      welcome:'',
      wetips:'',
      ShowDefault:0,
      to_user_id: '',
      to_user_name: '',
      pageNum: 1,
      pageSize: 10,
      chat_type: '',
      max_id: '',
      max_time: '',
      GetNew: null,
      chat_id: '',
      oldCount: '',
      IsNotedata: false,
      typeName: ''
    }
  },
  components:{
  //   Menu
  },
  computed: {
      
    noMore () {
      return this.count >= 30
    },
    disabled () {
      return this.loading || this.noMore
    }
  },
  methods:{
    toUserInfo(){
      let data = {
        chat_type: this.chat_type,
        to_user_id: this.to_user_id
      }

      this.$store.dispatch('session/toUserInfo',data)
        .then(res => {
          if(res.ok){
            console.log('GetToUserInfo')
            var info = res.data
            // this.to_user_name = info.name
            //console.log(info)
          }
        })
    },
    listSelf(data){
        this.$store.dispatch('session/listSelf',data)
          .then(res => {
            if(res.ok){
              var items = res.data.items
              var dpn = items.length
              if(dpn > 0){
                items.forEach(item => {
                  item.create_time = getTimeDate(item.create_time)
                  this.info.push(item)
                });
                this.max_id = this.info[0].id
                this.max_time = this.info[0].create_time
                
                this.info.reverse()
                
                // this.info.sort(function(a,b){
                // 	return a.create_time - b.create_time
                // })

                this.scrollToBottom()
              }
            }
          })
    },
    GetChatInfo() {
      let data = {
        chat_type: 'chat_expert',
        to_user_id: this.to_user_id
      }
      this.$store.dispatch('session/infoByUser',data)
        .then(res =>{
          if(res.ok){
              this.chat_id = res.data.id
          }
        })
      
    },
    GetListNew(){
        this.data = {
          pageNum: '1',
          pageSize: '99',
          to_user_id: this.to_user_id,
          chat_type: this.chat_type,
          max_id: this.max_id,
          max_time: this.max_time
        }

        this.$store.dispatch('session/list_self_new')
          .then(res => {
            if(res.ok){
              var items = res.data.items
              var dpn = items.length
              if(dpn > 0){
                items.forEach(item => {
                    item.create_time = getTimeDate(timeDate)
                    this.info.push(item)
                });
                this.max_id = this.info[0].id
                this.max_time = this.info[0].create_time
                this.scrollToBottom()
              }
            }
                
        })
    },
    send(){
      if(!this.IsNotedata){
        this.IsNotedata = true
    
        let data = {
          to_user_id: this.to_user_id,
          message: this.notedata,
          chat_type: this.chat_type,
          chat_id: this.chat_id
        }

        this.$store.dispatch('session/selfAdd',data)
          .then(res => {
            if(res.ok){
              var item = res.data
              this.max_id = item.id
              item.create_time = getTimeDate(item.create_time)
              this.max_time = item.create_time
                          
              this.info.push(item)
              this.notedata = ''
              this.scrollToBottom()
              this.IsNotedata = false
            }else{
              this.$notify({
                title: '提示',
                message: res.msg,
                type: 'error'
              })
            }
          })
        }
    },
    addDate(){
      const nowDate = new Date()
      const date = {
          year: nowDate.getFullYear(),
          month: nowDate.getMonth() + 1,
          date: nowDate.getDate()
      }
      const newmonth = date.month > 10 ? date.month : '0' + date.month
      const day = date.date > 10 ? date.date : '0' + date.date
      this.updateTime = date.year + '-' + newmonth + '-' + day
    },
    scrollToBottom() {
      this.$nextTick(() => {
          var container = this.$el.querySelector(".top-main");
          container.scrollTop = container.scrollHeight;
      })
    },
    async showScroll() {
      let st = document.getElementById('output').scrollTop
      // let sh = document.getElementById('output').scrollHeight
    
      if (st === 0) {
        console.log('到顶了;')
      
        
        this.loading = true
        let data = ['21','22','23','24','25','26','27','28','29','30','31','32','33','34','35','36','37','38','39','40']
        // this.count.unshift(data)
        await data.forEach(item => {
            this.count.unshift(item)
        });
      
          
            
        this.loading = false
        // setTimeout(() => {
          
            
          
            
        // }, 2000)
        this.newScroll()
      }
        
    },
    newScroll(){
      
      this.oldCount = 1 + 20
              
      let target = document.getElementById(this.oldCount);
      let parent = document.getElementById('output');
    
      parent.scrollTop = target.offsetTop - parent.offsetTop;
    }
  },
  created(){
      this.to_user_id = this.$route.query.to_user_id
      this.chat_type = this.$route.query.chat_type
      this.to_user_name = this.$route.query.to_user_name
      this.typeName = this.$route.query.type
      let data = {
          pageNum: '1',
          pageSize: "20",
          to_user_id: this.to_user_id,
          chat_type: this.chat_type
      }
      this.toUserInfo()
      this.listSelf(data)
      this.GetChatInfo()
      this.scrollToBottom()
      
  }
}
</script>

<style lang='scss' scoped>

.container{
  width: 1200px; min-height: calc(100vh - 215px);
  margin: 55px auto;
  .current{
    margin-top: -45px;
    position: relative;
    font-size: 17px;
    color: #333;
  }
  .session-box{
      margin-top: 10px;
      width: 100%;
    .session-main{
      
      height: calc(100vh - 195px);
      background: #fff;
      padding: 10px 10px;
      position: relative;
      .listNew{
          padding-bottom: 10px;
          padding: 10px 10px;
          background: #F5F5F5;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .expertName{
              font-size: 20px;
              color: #333333;
              
          }
          div {
              font-size: 18px;
              color: #666666;
              div:nth-child(2){
                  cursor: pointer;
              }
              div:nth-child(2):hover{
                  color: #10aeff;
                  cursor: pointer;
              }
          }
      }
      
      .top-main{
          height: 85%;
          overflow-y: auto;
          background-color: #F5F5F5;
          padding: 0 10px;
          div{
              padding: 10px 0;
            
          }
          p{
              font-size: 12px;
              color: #666666;
              margin-bottom: 2px;
          }
          span{
              font-size: 14px;
              color: #333333;
          }
          .rightInfo{
              width: 100%;
              display: flex;
              justify-content:flex-end;
              div{
                  max-width: 80%;
                  .time{
                      text-align: right;
                      font-size: 12px;
                  }
                  .contextP{
                      margin-left: auto;
                      
                      span{
                          float: right;
                          padding: 10px 10px;
                          border-bottom-right-radius: 10px;
                          background-color: #99ec68;
                          border-top-left-radius: 10px;
                          border-bottom-left-radius: 10px;
                      }
                      
                  }
              }
          
          
          
          }
          .leftInfo{
              width: 100%;
          
              div{
                  max-width: 80%;
                  .contextP{
                      span{
                          display: inline-block;
                          padding: 10px 10px;
                          border-bottom-right-radius: 10px;
                          background-color: #fff;
                          border-top-right-radius: 10px;
                          border-bottom-left-radius: 10px;
                      }
                  }
              }
        }
        .contextP{
          max-width: 100%;
          margin-top: 8px;
          span{
              word-break: break-all;
              white-space: normal; 
              line-height: 23px;
              
          }
        }
      }
      .top-main::-webkit-scrollbar {
        width: 8px;
        height: 8px;
      }

      .top-main::-webkit-scrollbar-track {
          background-color:transparent;
          -webkit-border-radius: 2em;
          -moz-border-radius: 2em;
          border-radius:2em;
      }
      .top-main::-webkit-scrollbar-thumb {
          // background-color: rgb(147,147,153,0.5);
          -webkit-border-radius: 2em;
          -moz-border-radius: 2em;
          border-radius:2em;
      }
      .bottom-input{
        padding: 10px 10px 0px 10px;
        
        height: 50px;
      //   position: absolute;
      //   bottom: 10px;
        background-color: #F5F5F5;
        .el-input{
          width: 90%;
        }
        .el-button{
          margin-left: 38px;
        }
      }
    }
  }
}

ul{
  margin: 0 0;
  padding: 0 0;
  font-size: 14px;
  color: #333333;
  li{
    margin: 3px 5px;
    cursor: pointer;
    height: 52px;
    line-height: 52px;
    font-size: 18px;
    color: #303133;
  }
  li:hover{
    color: #00a8a8;
  }
}
.activeColor{
  color: #00a8a8;
}
</style>